module.exports = __webpack_public_path__ + "static/media/pencil.2ccfbec1.svg";